import * as l from "react";
const m = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "NZ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#NZ_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "NZ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#NZ_svg__b)" }, /* @__PURE__ */ l.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "NZ_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#NZ_svg__c)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "NZ_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#NZ_svg__d)"
    }
  )), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.1 7.47l-.26 1.514 1.36-.714 1.36.714-.26-1.514 1.1-1.072-1.52-.22L25.2 4.8l-.68 1.377-1.52.221 1.1 1.072zm-4 5.6l-.26 1.514 1.36-.715 1.36.715-.26-1.514 1.1-1.072-1.52-.221-.68-1.378-.68 1.378-1.52.22 1.1 1.073zm3.327 6.393l-.337 1.964 1.764-.927 1.763.927-.337-1.963 1.427-1.391-1.972-.287L24.854 16l-.882 1.787-1.972.286 1.427 1.39zm3.412-4.884l.26-1.512-1.1-1.071 1.52-.22.678-1.377.68 1.376 1.518.221-1.099 1.071.26 1.512-1.359-.714-1.358.714z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M23.84 8.984l-.197-.033-.068.4.358-.19-.093-.177zm.26-1.514l.197.034.018-.103-.075-.074-.14.143zm1.1.8l.093-.177-.093-.05-.093.05.093.177zm1.36.714l-.093.177.358.19-.068-.4-.197.033zM26.3 7.47l-.14-.143-.075.074.018.103.197-.034zm1.1-1.072l.14.143.29-.282-.401-.059-.029.198zm-1.52-.22l-.18.088.047.094.104.015.029-.198zM25.2 4.8l.18-.089-.18-.363-.18.363.18.089zm-.68 1.377l.029.198.104-.015.047-.094-.18-.089zM23 6.398l-.029-.198-.4.059.29.282.14-.143zm-3.16 8.186l-.197-.034-.068.4.358-.189-.093-.177zm.26-1.514l.197.034.018-.104-.075-.073-.14.143zm1.1.8l.093-.178-.093-.049-.093.05.093.176zm1.36.714l-.093.177.358.189-.068-.4-.197.034zm-.26-1.514l-.14-.143-.075.073.018.104.197-.034zm1.1-1.072l.14.143.29-.283-.401-.058-.029.198zm-1.52-.221l-.18.088.047.095.104.015.029-.198zm-.68-1.378l.18-.088-.18-.364-.18.364.18.088zm-.68 1.378l.029.198.104-.015.047-.095-.18-.088zm-1.52.22l-.029-.197-.4.058.29.283.139-.143zm4.09 9.43l-.197-.034-.068.4.358-.189-.093-.177zm.337-1.963l.197.033.018-.103-.075-.074-.14.143zm1.427 1.036l.093-.177-.093-.049-.093.049.093.177zm1.763.927l-.093.177.359.189-.069-.4-.197.034zm-.337-1.963l-.14-.144-.075.074.018.103.197-.034zm1.427-1.391l.14.143.29-.283-.402-.058-.028.198zm-1.972-.287l-.18.089.047.094.104.015.03-.198zM24.854 16l.179-.088-.18-.364-.179.364.18.088zm-.882 1.787l.029.197.104-.015.046-.094-.18-.088zM22 18.073l-.028-.198-.401.058.29.283.14-.143zm5.099-5.006l.197.034.018-.104-.076-.073-.14.143zm-.26 1.512l-.197-.033-.068.399.358-.189-.093-.177zM26 11.996l-.028-.198-.4.058.29.283.139-.143zm1.52-.22l.028.197.104-.015.047-.094-.18-.089zm.678-1.377l.18-.088-.18-.364-.179.364.18.088zm.68 1.376l-.18.089.047.094.104.015.029-.198zm1.518.221l.14.143.29-.283-.401-.058-.029.198zm-1.099 1.071l-.14-.143-.075.073.018.104.197-.034zm.26 1.512l-.094.177.36.189-.07-.4-.196.034zm-1.359-.714l.094-.177-.094-.049-.093.05.093.176zm-4.16-4.847l.26-1.514-.394-.067-.26 1.514.395.067zm1.07-.925l-1.36.714.186.354 1.36-.714-.186-.354zm1.546.714l-1.36-.714-.186.354 1.36.714.186-.354zm-.55-1.303l.26 1.514.394-.067-.26-1.514-.394.067zm1.157-1.249l-1.1 1.072.28.287 1.1-1.073-.28-.286zm-1.409.12l1.52.221.058-.396-1.52-.22-.058.395zm-.83-1.487l.68 1.378.358-.177-.68-1.378-.358.177zM24.7 6.266l.68-1.378-.36-.177-.68 1.378.36.177zm-1.671.33l1.52-.22-.058-.397-1.52.221.058.396zm1.21.731l-1.1-1.072-.279.286 1.1 1.073.28-.287zm-4.202 7.29l.26-1.513-.394-.068-.26 1.514.394.068zm1.07-.925l-1.36.715.186.354 1.36-.715-.186-.354zm1.546.715l-1.36-.715-.186.354 1.36.715.186-.354zm-.55-1.303l.26 1.514.394-.068-.26-1.514-.394.068zm1.157-1.25l-1.1 1.073.28.286 1.1-1.072-.28-.286zm-1.409.12l1.52.222.058-.396-1.52-.221-.058.396zm-.83-1.486l.68 1.377.358-.177-.68-1.377-.358.177zm-.322 1.377l.68-1.377-.358-.177-.68 1.377.358.177zm-1.67.33l1.52-.22-.058-.396-1.52.22.058.397zm1.21.732l-1.1-1.072-.279.286 1.1 1.072.28-.286zm3.048 8.534l.337-1.964-.394-.067-.337 1.963.394.068zm1.474-1.138l-1.764.927.186.354 1.764-.927-.186-.354zm1.949.927l-1.763-.927-.186.354 1.763.927.186-.354zm-.627-1.753l.337 1.964.394-.068-.337-1.963-.394.067zm1.484-1.567l-1.426 1.39.279.287 1.426-1.39-.279-.287zm-1.86.054l1.971.287.057-.396-1.971-.286-.058.395zm-1.033-1.896l.882 1.787.359-.177-.882-1.787-.359.178zm-.523 1.787l.882-1.787-.359-.177-.881 1.787.358.177zm-2.122.396l1.972-.287-.058-.395-1.971.286.057.396zm1.538 1.05L22.14 17.93l-.28.286 1.427 1.39.28-.286zm3.334-6.288l-.259 1.513.394.067.26-1.512-.395-.068zm-1.04-.894l1.098 1.071.28-.286-1.1-1.071-.279.286zm1.629-.561l-1.519.22.058.396 1.518-.22-.057-.396zm.528-1.267l-.679 1.376.359.177.679-1.376-.359-.177zm1.038 1.376l-.68-1.376-.358.177.68 1.376.358-.177zm1.368.111l-1.519-.22-.057.395 1.518.221.058-.396zm-.988 1.412l1.099-1.07-.28-.287-1.098 1.07.279.287zm.317 1.336l-.26-1.513-.394.068.26 1.512.394-.067zm-1.649-.504l1.358.714.187-.354-1.358-.714-.187.354zm-1.172.714l1.359-.714-.187-.354-1.358.714.186.354z",
      fill: "#F7FCFF"
    }
  )))
), z = m;
export {
  z as default
};
